export default {
      id: "ic_billetterie-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_billetterie-usage",
      toString: function () {
        return this.url;
      }
    }